import {
  FileInput as MantineFileInput,
  FileInputProps as MantineFileInputProps,
} from "@mantine/core"
import { forwardRef, ReactNode } from "react"

import { EqualWidthGrid } from "../../../layout/EqualWidthGrid/EqualWidthGrid"
import { buildLabel } from "../utils"

export type FileInputProps = Omit<MantineFileInputProps, "ref"> & {
  label: string | ReactNode
  description?: string
  error?: string
  required?: boolean
  isLoading?: boolean
  inlineLabel?: boolean
  toolTip?: string
}

export const FileInput = forwardRef<HTMLButtonElement, FileInputProps>(
  (
    { label, description, required, isLoading, inlineLabel, toolTip, ...props },
    ref
  ) => {
    const finalLabel = buildLabel({ label, isLoading, toolTip })
    const input = (
      <MantineFileInput
        ref={ref}
        {...props}
        label={inlineLabel ? undefined : finalLabel}
      />
    )

    if (inlineLabel) {
      return (
        <EqualWidthGrid>
          {finalLabel}
          {input}
        </EqualWidthGrid>
      )
    }
    return input
  }
)

FileInput.displayName = "FileInput"
